/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSubjectList } from '../../redux/sclassRelated/sclassHandle';
import { getUserDetails } from '../../redux/userRelated/userHandle';
import CustomBarChart from '../../components/CustomBarChart';

import {
    BottomNavigation,
    BottomNavigationAction,
    Container,
    Paper,
    Table,
    TableBody,
    TableHead,
    Typography,
    useMediaQuery,
    ThemeProvider,
    createTheme,
    Button
} from '@mui/material';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import TableChartIcon from '@mui/icons-material/TableChart';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import { StyledTableCell, StyledTableRow } from '../../components/styles';

const theme = createTheme({
    palette: {
        primary: { main: '#008080' }, // Teal
        secondary: { main: '#FFD700' }, // Gold
    },
    typography: {
        fontFamily: 'Poppins, sans-serif',
    },
});

const StudentSubjects = () => {
    const dispatch = useDispatch();
    const { subjectsList, sclassDetails } = useSelector((state) => state.sclass);
    const { userDetails, currentUser, loading, response, error } = useSelector((state) => state.user);

    useEffect(() => {
        dispatch(getUserDetails(currentUser._id, "Student"));
    }, [dispatch, currentUser._id]);

    if (response) console.log(response);
    else if (error) console.log(error);

    const [subjectMarks, setSubjectMarks] = useState([]);
    const [selectedSection, setSelectedSection] = useState('table');

    useEffect(() => {
        if (userDetails) {
            setSubjectMarks(userDetails.examResult || []);
        }
    }, [userDetails]);

    useEffect(() => {
        if (!subjectMarks.length) {
            dispatch(getSubjectList(currentUser.sclassName._id, "ClassSubjects"));
        }
    }, [subjectMarks, dispatch, currentUser.sclassName._id]);

    const handleSectionChange = (event, newSection) => {
        setSelectedSection(newSection);
    };

    const isMobile = useMediaQuery('(max-width:600px)');

    const renderTableSection = () => (
        <>
            <Typography variant="h4" align="center" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                Subject Marks
            </Typography>
            <Table>
                <TableHead>
                    <StyledTableRow>
                        <StyledTableCell>Subject</StyledTableCell>
                        <StyledTableCell>Marks</StyledTableCell>
                    </StyledTableRow>
                </TableHead>
                <TableBody>
                    {subjectMarks.map((result, index) => (
                        result.subName && result.marksObtained ? (
                            <StyledTableRow key={index}>
                                <StyledTableCell>{result.subName.subName}</StyledTableCell>
                                <StyledTableCell>{result.marksObtained}</StyledTableCell>
                            </StyledTableRow>
                        ) : null
                    ))}
                </TableBody>
            </Table>
        </>
    );

    const renderChartSection = () => <CustomBarChart chartData={subjectMarks} dataKey="marksObtained" />;

    const renderClassDetailsSection = () => (
        <Container>
            <Typography variant="h4" align="center" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                Class Details
            </Typography>
            <Typography variant="h5" gutterBottom>
                You are currently in Class {sclassDetails && sclassDetails.sclassName}
            </Typography>
            <Typography variant="h6" gutterBottom>And these are the subjects:</Typography>
            {subjectsList &&
                subjectsList.map((subject, index) => (
                    <Typography key={index} variant="subtitle1" sx={{ color: 'secondary.main', fontWeight: 'bold' }}>
                        {subject.subName} ({subject.subCode})
                    </Typography>
                ))}
        </Container>
    );

    return (
        <ThemeProvider theme={theme}>
            {loading ? (
                <Typography align="center" variant="h6" sx={{ color: 'primary.main' }}>Loading...</Typography>
            ) : (
                <div>
                    {subjectMarks.length > 0 ? (
                        <>
                            {selectedSection === 'table' && renderTableSection()}
                            {selectedSection === 'chart' && renderChartSection()}

                            <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
                                <BottomNavigation
                                    value={selectedSection}
                                    onChange={handleSectionChange}
                                    showLabels
                                    sx={{ backgroundColor: 'primary.main' }}
                                >
                                    <BottomNavigationAction
                                        label="Table"
                                        value="table"
                                        icon={
                                            selectedSection === 'table' ? <TableChartIcon sx={{ color: 'secondary.main' }} /> : <TableChartOutlinedIcon sx={{ color: 'white' }} />
                                        }
                                    />
                                    <BottomNavigationAction
                                        label="Chart"
                                        value="chart"
                                        icon={
                                            selectedSection === 'chart' ? <InsertChartIcon sx={{ color: 'secondary.main' }} /> : <InsertChartOutlinedIcon sx={{ color: 'white' }} />
                                        }
                                    />
                                </BottomNavigation>
                            </Paper>
                        </>
                    ) : (
                        renderClassDetailsSection()
                    )}
                </div>
            )}
        </ThemeProvider>
    );
};

export default StudentSubjects;
